import { useQuery } from '@tanstack/react-query';
import { fetchCart, fetchMyCarts } from '../queries/carts.queries';

export const useMyCarts = () => {
    return useQuery({
        queryKey: ['myCarts'],
        queryFn: fetchMyCarts,
    });
};

export const useCart = (id: number) => {
    return useQuery({
        queryKey: ['cart', id],
        queryFn: () => {
            if (Number.isNaN(id)) {
                return null;
            }
            return fetchCart(id);
        },
    });
};
